class CustomError extends Error {
    constructor(message, code) {
        super(message); // (1)
        this.name = "CustomError"; // (2)
        this.code = code;
    }
}

export default CustomError;
